import { createChildFormViewContainer } from 'factories/ChildFormView'
import actions from 'actions/jobs/jobChecklist'
import Component from 'components/Jobs/Checklist/FormView'

export default createChildFormViewContainer({ actions })(Component)
